import { configureStore } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

import initReducer from "../store/init/initSlice";
import requestsReducer from "./requests/requestsSlice";
import UterumReducer from "../store/Uterum/UterumSlice";
import OptionsReducer from "../store/Options/OptionsSlice";
import ImagesReducer from "../store/Images/ImagesSlice";
import ResultReducer from "../store/Result/ResultSlice";
import MiscReducer from "../store/Misc/MiscSlice";

/*
NOTE:
- Lowercase is used for internal application data
- Upper camelcase is used for everything from backend APIs
*/

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) => {
    if (action.type === "thunks/requestEmailUterum") {
      // Return null to not log the action to Sentry
      return null;
    }

    return action;
  },
});

const store = configureStore({
  reducer: {
    init: initReducer,
    requests: requestsReducer,
    Uterum: UterumReducer,
    Options: OptionsReducer,
    Images: ImagesReducer,
    Result: ResultReducer,
    Misc: MiscReducer,
  },
  enhancers: [sentryReduxEnhancer],
});

export default store;
